/* eslint-disable import/no-anonymous-default-export */
export default {
    green: "#64E786",
    orangeDark: "#E54C00",
    tealDark: "#00A5B8",
    white: "#FFFFFF",
};
  